import { FC } from 'react';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';
import { Button } from '@wwe-portal/ui/components/button';
import { useTranslations } from 'next-intl';
import { cn } from '@wwe-portal/ui/lib/lib';
import { ClaimStatus } from './type';

const statusMap = {
  unknown: 'none',
  claimed: 'green',
  unclaimed: 'blue',
  disabled: 'none',
} as const;

export const ClaimButton: FC<{
  status: ClaimStatus;
  onClick: () => void;
  isLoading: boolean;
  className?: string;
  requiredPoint: number | undefined;
  totalPoints: number | undefined;
}> = ({
  status,
  onClick,
  isLoading,
  className,
  requiredPoint,
  totalPoints = 0,
}) => {
  const t = useTranslations();
  const isDisabled = status === 'disabled' || status === 'unknown';
  const buttonElement = (
    <Button
      variant={statusMap[status]}
      disabled={status === 'disabled' || status === 'unknown'}
      className={cn('h-8 w-full text-xs font-semibold', {
        'pointer-events-none': status !== 'unclaimed',
      })}
      onClick={onClick}
      loading={isLoading}
      loadingText={t('processing')}
    >
      {t(`milestone_claim.status.${status}`)}
    </Button>
  );

  if (!isDisabled || requiredPoint == null) {
    return <div className={className}>{buttonElement}</div>;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={cn('cursor-help', className)}>{buttonElement}</div>
      </TooltipTrigger>
      <TooltipContent className="w-[150px]">
        Earn {requiredPoint - totalPoints} more XP to Claim reward
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
